module.exports = __webpack_public_path__ + "img/building-07.e417ba1d.svg";